import { tss } from 'tss-react/mui';

export const useStylesProductPageUXB = tss.create(({ theme }) => ({
  // eslint-disable-next-line tss-unused-classes/unused-classes
  productInformationGrid: {
    display: 'grid',
    gap: '48px',
    gridTemplateColumns: '200px 1fr',
    [`${theme.breakpoints.down('md')}`]: {
      gridTemplateColumns: '1fr'
    }
  }
}));
